export const ViewAppointmentForm = (appt) => ({
  name: 'view-appointment',
  inputs: {
    name: { 
      component: 'input', 
      type: 'text', 
      value: appt.name, 
      placeholder: 'Name', 
      label: 'Name' 
    },
    startDate: { 
      component: 'input', 
      type: 'date', 
      value: appt.dateInternational, 
      placeholder: '', 
      label: 'Start Date' 
    },
    service: { 
      component: 'select',
      type: '', 
      value: 'Assessment', 
      placeholder: '', 
      label: 'Service',
      disabled: true,
      options: [
        {
          label: 'Assessment',
          value: 'Assessment',
        },
      ]
    },
    startTime: { 
      component: 'select',
      type: '', 
      value: 930, 
      placeholder: '', 
      label: 'Start Time',
      options: [
        {
          label: '9:00 am',
          value: 900
        },
        {
          label: '9:30 am',
          value: 930
        }
      ]
    },
    duration: { 
      component: 'select',
      type: '', 
      value: 30, 
      placeholder: '', 
      label: 'Duration',
      options: [
        {
          label: '30 mins',
          value: 30
        },
        {
          label: '60 mins',
          value: 60
        }
      ]
    },
    resources: { 
      component: 'select',
      type: '', 
      value: 'Janice Joplin', 
      placeholder: '', 
      label: 'Resources',
      disabled: true,
      options: [
        {
          label: 'Janice Joplin',
          value: 'Janice Joplin',
        },
        {
          label: 'Jim Morrison',
          value: 'Jim Morrison',
        },
      ]
    },
  },
})